import es from './es-MX'
import en from './en-US'

export default{
    ...es,
    ...en,
}